import Vue from "vue";
import Vuex from "vuex";
import user from "./store/modules/user";
import clubs from "./store/modules/clubs";
import finances from "./store/modules/finances";
import documentation from "./store/modules/documentation";
import navigation from "./store/modules/navigation";
import events from "./store/modules/events";
import persons from "./store/modules/persons";
import volunteers from "./store/modules/volunteers";
import notes from "./store/modules/notes";
import teams from "./store/modules/teams";
import hotels from "./store/modules/hotels";
import facilitys from "./store/modules/facilitys";
import travels from "./store/modules/travels";
import companies from "./store/modules/companies";
import competition from "./store/modules/competition";
import matches from "./store/modules/matches";
import confirmations from "./store/modules/confirmations";
import router from "@/router";

import { Api } from "@/core/api.js";
const api = new Api();

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

let notifier = new Vue();

export default new Vuex.Store({
  state: {
    usermenu_is_visible: false,
    menu_is_visible: false,
    language: localStorage.language ? localStorage.language : "cat",
    languages: [],
    title: "MIC",
    app_url: "http://localhost:8087",
    search: "",
    is_loading: false,
    table_relatioship: false,
    topbar_actions_visible: false,
    topbar_filter_visible: false,
    event_selected: false,
    show_event_list: false,
    current_page: "home",
    current_event: false,
    countries: [],
    how_meet: [],
    role_volunteer: [],
    volunteer_3po_options: [],
    language_volunteer: [],
    studies: [],
    working_areas: [],
    staff_level: [],
    transport_mode: [],
    sports: [],
    hotel_services: [],
    modes_registered: [],
    topbar_buttons_visible: true,
    overlay_is_visible: false,
    documents_person: {
      1: { id: 1, name: "params.dni" },
      2: { id: 2, name: "params.nie" },
      3: { id: 3, name: "params.passport" },
    },
    bus_types: {
      1: { id: 1, name: "campus.bus_type.go" },
      2: { id: 2, name: "campus.bus_type.back" },
      3: { id: 3, name: "campus.bus_type.both" },
    },
    pickupOptions: {
      1: { name: "campus.pickup.bcncenter", id: 1 },
      2: { name: "campus.pickup.bcnsants", id: 2 },
      3: { name: "campus.pickup.bcnairport", id: 3 },
      0: { name: "bool.no", id: 0 },
    },
    yesno: {
      1: { name: "bool.si", id: 1 },
      0: { name: "bool.no", id: 0 },
    },
    reject_documents: [],
    team_division: [],
    travel_types: []
  },
  modules: {
    user,
    clubs,
    navigation,
    events,
    persons,
    volunteers,
    notes,
    teams,
    hotels,
    facilitys,
    travels,
    companies,
    finances,
    documentation,
    competition,
    matches,
    confirmations
  },
  strict: debug,
  mutations: {
    setMenuVisible(state, value) {
      state.menu_is_visible = value;
    },

    setOverlayVisible(state, value) {
      state.overlay_is_visible = value;
    },

    setEventListVisible(state, value) {
      state.show_event_list = value;
    },

    setUserMenuVisible(state, value) {
      state.usermenu_is_visible = value;
    },

    setTopbarActionsVisible(state, value) {
      state.topbar_actions_visible = value;
    },
    setTopbarButtonsVisible(state, value) {
      state.topbar_buttons_visible = value;
    },

    setTopFiltersVisible(state, value) {
      state.topbar_filter_visible = value;
    },

    setTitle(state, value) {
      state.title = value;
    },

    setSearch(state, value) {
      state.search = value;
    },

    setLoading(state, value) {
      state.is_loading = value;
    },

    setLanguage(state, value) {
      for (var k in this.languages) {
        if (this.languages[k].name == value) this.languages[k].selected = true;
        else this.languages[k].selected = false;
      }
      state.language = value;
      localStorage.language = value;
    },

    setTables(state, tables) {
      state.table_relatioship = true;

      if (typeof tables["country"] !== "undefined") {
        state.countries = tables["country"];
      }
      if (typeof tables["alergy"] !== "undefined") {
        state.persons.alergies = tables["alergy"];
      }
      if (typeof tables["contact_type"] !== "undefined") {
        state.persons.contact_types = tables["contact_type"];
      }
      if (typeof tables["rel_status_event"] !== "undefined") {
        state.events.status_entities = tables["rel_status_event"];
      }
      if (typeof tables["player_position"] !== "undefined") {
        state.persons.player_positions = tables["player_position"];
      }
      if (typeof tables["how_meet"] !== "undefined") {
        state.how_meet = tables["how_meet"];
      }
      if (typeof tables["mode_register_event"] !== "undefined") {
        state.modes_registered = tables["mode_register_event"];
      }
      if (typeof tables["user"] !== "undefined") {
        state.user.list = tables["user"];
      }
      if (typeof tables["language"] !== "undefined") {
        state.languages = tables["language"];
      }
      if (typeof tables["staff_level"] !== "undefined") {
        state.staff_level = tables["staff_level"];
      }
      if (typeof tables["diet"] !== "undefined") {
        state.diet = tables["diet"];
      }
      if (typeof tables["join_campus"] !== "undefined") {
        state.join_campus = tables["join_campus"];
      }
      if (typeof tables["shirt_size"] !== "undefined") {
        state.shirt_size = tables["shirt_size"];
      }
      if (typeof tables["volunteer_shirt_size"] !== "undefined") {
        state.volunteer_shirt_size = tables["volunteer_shirt_size"];
      }
      if (typeof tables["volunteer_shoes_size"] !== "undefined") {
        state.volunteer_shoes_size = tables["volunteer_shoes_size"];
      }
      if (typeof tables["service_type"] !== "undefined") {
        state.service_type = tables["service_type"];
      }
      if (typeof tables["service"] !== "undefined") {
        state.service = tables["service"];
      }
      if (typeof tables["travel_options"] !== "undefined") {
        state.travel_options = tables["travel_options"];
      }
      if (typeof tables["rel_status_participant"] !== "undefined") {
        state.rel_status_participant = tables["rel_status_participant"];
      }
      if (typeof tables["transport_mode"] !== "undefined") {
        state.transport_mode = tables["transport_mode"];
      }
      if (typeof tables["role_volunteer_event"] !== "undefined") {
        state.role_volunteer = tables["role_volunteer_event"];
      }
      if (typeof tables["language_volunteer"] !== "undefined") {
        state.language_volunteer = tables["language_volunteer"];
      }
      if (typeof tables["studies"] !== "undefined") {
        state.studies = tables["studies"];
      }
      if (typeof tables["working_areas"] !== "undefined") {
        state.working_areas = tables["working_areas"];
      }
      if (typeof tables["volunteer_3po_options"] !== "undefined") {
        state.volunteer_3po_options = tables["volunteer_3po_options"];
      }
      if (typeof tables["sport"] !== "undefined") {
        state.sports = tables["sport"];
      }
      if (typeof tables["event_type"] !== "undefined") {
        state.events.event_types = tables["event_type"];
      }
      if (typeof tables["hotel_service"] !== "undefined") {
        state.hotel_services = tables["hotel_service"];
      }
      if (typeof tables["hotel_category"] !== "undefined") {
        state.hotels.category = tables["hotel_category"];
      }
      if (typeof tables["rooming_status"] !== "undefined") {
        state.hotels.rooming_status = tables["rooming_status"];
      }
      if (typeof tables["rel_punishment_event"] !== "undefined") {
        state.competition.punishments = tables["rel_punishment_event"];
      }
      if (typeof tables["reject_documents"] !== "undefined") {
        state.reject_documents = tables["reject_documents"];
      }
      if (typeof tables["event"] !== "undefined") {
        state.events.list = tables["event"];
      }
      if (typeof tables["team_division"] !== "undefined") {
        state.team_division = tables["team_division"];
      }
      if (typeof tables["locations"] !== "undefined") {
        state.travels.locations = tables["locations"];
      }
      if (typeof tables["travel_types"] !== "undefined") {
        state.travel_types = tables["travel_types"];
      }
    },

    setEventSelected(state, value) {
      state.event_selected = value;
    },

    setCurrentPage(state, page) {
      state.current_page = page;
    },
  },
  actions: {
    loadTablesRelationship: ({ commit }) => {
      //console.log("loadTablesRelationship");
      return api.get("table").then(function (data) {
        if (data.status) {
          //console.log( data.data );
          return commit("setTables", data.data);
        }
      });
    },

    loadUser({ commit, dispatch }) {
      return api.get("init").then(function (data) {
        if (data.status) {
          dispatch("loadTablesRelationship");
          commit("events/setEventsActive", data.data.events);
          return commit("user/setAuthenticate", data.data);
        }
      });
    },

    logout({ commit }) {
      // commit( 'locations/setLocations', [] );
      commit("user/logoutUser");
    },

    setPage({ commit, dispatch, state }, page) {
      notifier.$overlay.loading();

      return new Promise((resolve, reject) => {
        if (page.name != "home" && page.name != "event_home") {
          commit("setTopbarActionsVisible", true);
          commit("setMenuVisible", true);
          commit("setTopbarButtonsVisible", true);
        } else {
          commit("setTopbarActionsVisible", false);
          commit("setMenuVisible", false);
        }

        var page2 = page.name.replace("event_", "");

        commit("setUserMenuVisible", false);
        commit("setEventListVisible", false);

        commit("setCurrentPage", page2);
        commit("navigation/pushPage", page);

        if (page.name.includes("event_") && !state.event_selected) {
          var event = page.params.event;
          commit("setEventSelected", true);
          //TODO THIS ONLY WORKS WITH ACTIVES EVENTS, WE'LL NEED CHANGE TO
          // var current_events = [...state.events.actives];
          // for( var i in current_events ){
          // 	if( ( current_events[ i ].name + current_events[ i ].edition.substring(2) ).toLowerCase() == event ) commit( 'events/setCurrentEvent', current_events[ i ] );
          // }
          //console.log( "--- DISPATCH LOAD BY NAME: " + event + " ---" );
          dispatch("events/loadByName", event).then(function () {
            resolve();
          });
        } else if (!page.name.includes("event_")) {
          commit("setEventSelected", false);
          commit("events/setCurrentEvent", {});
          resolve();
        } else {
          resolve();
        }
      });
    },
  },
  getters: {
    getTravelTypes: (state, getters, rootState) => () => {
      return state.travel_types;
    },

    getLanguages: (state, getter, rootState) => {
      return state.languages;
    },

    getCountries: (state, getters, rootState) => () => {
      return state.countries;
    },

    getYesNo: (state, getters, rootState) => () => {
      return state.yesno;
    },

    getCurrentPage: (state, getters, rootState) => {
      return state.current_page;
    },

    getEvents: (state, getters, rootState) => {
      return state.events;
    },

    getRoleVolunteer: (state, getters, rootState) => {
      return state.role_volunteer;
    },

    get3poOptions: (state, getters, rootState) => {
      return state.volunteer_3po_options;
    },

    getLanguageVolunteer: (state, getters, rootState) => {
      return state.language_volunteer;
    },

    getLanguageVolunteerFullname: (state, getters, rootState) => () => {
      var langReturn = {};
      for (var k in state.language_volunteer) {
        langReturn[k] = { ...state.language_volunteer[k] };
        langReturn[k].name = "language_volunteer." + langReturn[k].name;
      }

      return langReturn;
    },

    getStudies: (state, getters, rootState) => {
      return state.studies;
    },

    getWorkingAreas: (state, getters, rootState) => {
      return state.working_areas;
    },

    isEventSelected: (state, getters, rootState) => {
      return state.event_selected;
    },

    getCountryByID: (state, getter, rootState) => (id) => {
      return state.countries[id];
    },

    getHowMeet: (state, getter, rootState) => (id) => {
      if (typeof id !== "undefined") {
        if (state.how_meet[id]) return state.how_meet[id];
        return false;
      }
      return state.how_meet;
    },

    getModeRegistered: (state, getter, rootState) => (event_type) => {
      var aModes = state.modes_registered;
      var aReturn = [];
      for (var key in aModes) {
        var mode = { ...aModes[key] };
        if (mode.event_id == event_type || event_type == undefined) {
          mode.name = "mode." + mode.name;
          aReturn.push(mode);
        }
      }

      return aReturn;
    },

    getStaffLevel: (state, getter, rootState) => (level) => {
      if (level == undefined) return state.staff_level;
      else {
        var levelReturn = {};
        for (var k in state.staff_level) {
          if (level == k) {
            levelReturn = state.staff_level[k];
          }
        }

        return levelReturn;
      }
    },

    getOverlayVisible: (state, getter, rootState) => () => {
      return state.overlay_is_visible;
    },

    getDocumentsPersonType: (state, getter, rootState) => (id) => {
      if (typeof id !== "undefined") return state.documents_person[id];
      else {
        var doctypes = [];
        for (var k in state.documents_person) {
          doctypes.push(state.documents_person[k]);
        }

        return doctypes;
      }
    },

    getStatusVolunteer: (state, getter, rootState) => {
      return state.events.status_entities;
    },

    getTransportMode: (state, getter, rootState) => () => {
      return state.transport_mode;
    },

    getSports: (state, getter, rootState) => () => {
      return state.sports;
    },

    getStatusParticipants: (state, getter, rootState) => (id) => {
      if (typeof id !== "undefined") return state.rel_status_participant[id];
      return state.rel_status_participant;
    },

    getHotelServices: (state, getters, rootState) => () => {
      return state.hotel_services;
    },
    getBusTypes: (state, getters, rootState) => () => {
      return state.bus_types;
    },
    getPickUpOptions: (state, getters, rootState) => () => {
      return state.pickupOptions;
    },
    getRejectDocuments: (state, getters, rootState) => () => {
      return state.reject_documents;
    },
    getTeamDivision: (state, getters, rootState) => (event_type_id) => {
      if (event_type_id) {
        var divisions = {};
        // console.log("TEAM_DIVISIONS", state.team_division);
        for (var k in state.team_division) {
          //   console.log(
          //     "DIVISION",
          //     state.team_division[k].event_type_id,
          //     event_type_id
          //   );
          if (
            parseInt(state.team_division[k].event_type_id) ==
            parseInt(event_type_id)
          ) {
            divisions[k] = { ...state.team_division[k] };
          }
        }
        // console.log("DIVISION RETURNED", divisions);
        return divisions;
      }
      return state.team_division;
    },
    getTopbarActionsVisible: (state, getters, rootState) => () => {
      return state.topbar_actions_visible;
    },

    getTopFiltersVisible: (state, getters, rootState) => () => {
      return state.topbar_filter_visible;
    },
  },
});
